<div class="activities-dialog-title">
  <button  mat-dialog-close color="white"
    class="close mat-elevation-z1"
    aria-label="Close dialog">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>
<mat-dialog-content [ngClass]="{'js-latex-is-open' : isLatexKeyboardDisplayed}">

  <!-- in case user launch a sub lesson, need button to navigate in sub lesson-->
  @if (displayNavigation) {
    <div class="preview-wrapper">
      <button  (click)="launchPrevious()"
        [disabled]="canGoToPrevious === false"
        [style.visibility]="settings?.hideUserActionButtonsWhenDisabled && !canGoToPrevious?'hidden':'visible'"
        class="preview"
        aria-label="preview">
        <mat-icon svgIcon="arrow_left_circle_outline"></mat-icon>
      </button>
    </div>
  }

  <div class="multi-content">
    @if (template === TypologyLabel.multipleChoice) {
      <app-qcm #activeComponent [activityId]='currentActivity'></app-qcm>
    }
    @if (template === TypologyLabel.multipleChoiceUniqueAnswer) {
      <app-qcu #activeComponent [activityId]='currentActivity' [preview]="preview" [refresh]="refreshSubject"></app-qcu>
    }
    @if (template === TypologyLabel.summary) {
      <app-summary-activity #activeComponent [activityId]='currentActivity' [refresh]="refreshSubject"></app-summary-activity>
    }
    @if (template === TypologyLabel.trueFalse) {
      <app-true-false #activeComponent [activityId]='currentActivity'></app-true-false>
    }
    @if (template === TypologyLabel.shortAnswer) {
      <app-short-answer #activeComponent [activityId]='currentActivity'></app-short-answer>
    }
    @if (template === TypologyLabel.sort) {
      <app-ordon #activeComponent [activityId]='currentActivity'></app-ordon>
    }
    @if (template === TypologyLabel.textMatching) {
      <app-text-matching #activeComponent [activityId]='currentActivity'></app-text-matching>
    }
    @if (template === TypologyLabel.awareness) {
      <app-awareness #activeComponent [activityId]='currentActivity'></app-awareness>
    }
    @if (template === TypologyLabel.pairing) {
      <app-appaire #activeComponent [activityId]='currentActivity'></app-appaire>
    }
    @if (template === TypologyLabel.fillBlanks) {
      <app-fill-in-blanks #activeComponent [activityId]='currentActivity'></app-fill-in-blanks>
    }
    @if (template === TypologyLabel.divider) {
      <app-divider #activeComponent [activityId]='currentActivity'></app-divider>
    }
    @if (isMedia) {
      <app-media #activeComponent [activityId]='currentActivity'></app-media>
    }
    @if (template === TypologyLabel.external) {
      <app-external #activeComponent [activityId]='currentActivity'></app-external>
    }
    @if (template === TypologyLabel.interactiveImage) {
      <app-interactive-image #activeComponent [activityId]='currentActivity'></app-interactive-image>
    }
    @if (template === TypologyLabel.multimedia) {
      <app-multimedia #activeComponent [activityId]='currentActivity' [activityInput]='currentActivity' [refresh]="refreshSubject"></app-multimedia>
    }
    @if (template === TypologyLabel.recording) {
      <app-voice-recorder-activity #activeComponent [activityId]='currentActivity'></app-voice-recorder-activity>
    }
  </div>

  @if (displayNavigation) {
    <div class="next-wrapper">
      <button  (click)="launchNext()"
        [disabled]="canGoToNext === false"
        [style.visibility]="settings?.hideUserActionButtonsWhenDisabled && !canGoToNext?'hidden':'visible'"
        class="next"
        aria-label="next">
        <mat-icon svgIcon="arrow_right_circle_outline"></mat-icon>
      </button>
    </div>
  }



</mat-dialog-content>
@if (showBtnAction) {
  <mat-dialog-actions>
    <app-user-action-button
      fxfill
      [activityId]="currentActivity?.id"
      [activityTitle]="currentActivity?.get('title')?currentActivity?.get('title'): data.activityTitle"
      [isMedia]="isMedia"
    [ShowPrevNextBtns]='true'></app-user-action-button>
  </mat-dialog-actions>
}
